@if (open()) {
  <ng-container *transloco="let t">
    <!-- BACKDROP — mousedown (not click) so a text-drag that ends on the backdrop
         doesn't dismiss the modal. -->
    <div
      class="modal-backdrop fixed inset-0 z-[1100] flex items-center justify-center bg-scrim p-4"
      (mousedown)="onBackdropMouseDown()"
    >
      <!-- CARD — carries the dialog role; it *is* the dialog, not the backdrop. -->
      <div
        data-modal-card
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        [attr.aria-labelledby]="titleId"
        class="modal-card flex max-h-[calc(100dvh-2rem)] w-full flex-col overflow-hidden rounded-modal bg-card shadow-modal outline-none"
        [style.max-width.px]="widthPx()"
        [style.min-height]="minHeightPx() !== null ? 'min(' + minHeightPx() + 'px, 90vh)' : null"
        [style.height]="heightPx() !== null ? 'min(' + heightPx() + 'px, 90vh)' : null"
        (mousedown)="$event.stopPropagation()"
      >
        <!-- HEADER — DS modal Header: min-height 56, padding 16 16 16 32,
             hairline below (the design's only divider); no kind icon chip. -->
        <div class="flex min-h-14 flex-none items-start gap-3 border-b border-hairline py-4 pl-5 pr-4 sm:pl-8">
          <div class="min-w-0 flex-1">
            <!-- DS Header title: Figtree 700 24/28, letter-spacing .02em. -->
            <h2
              [id]="titleId"
              class="font-display text-h2 font-bold leading-7 tracking-[0.02em] text-ink-1"
            >
              {{ title() }}
            </h2>
            @if (subtitle()) {
              <p class="mt-1 text-[13px] leading-5 text-ink-2">{{ subtitle() }}</p>
            }
          </div>
          @if (headerActionTpl(); as h) {
            <ng-container [ngTemplateOutlet]="h.template" />
          }
          @if (dismissable()) {
            <button
              type="button"
              (click)="dismiss()"
              [attr.aria-label]="t('common.close')"
              class="flex h-8 w-8 flex-none items-center justify-center self-center rounded-control text-action hover:bg-sunken"
            >
              <app-icon name="icon-x" [size]="24" />
            </button>
          }
        </div>

        <!-- BODY (projected; scrolls itself unless the consumer owns layout) -->
        <div
          class="min-h-0 flex-1"
          [class.overflow-auto]="!flushBody()"
          [class.px-4]="!flushBody()"
          [class.py-4]="!flushBody()"
          [class.sm:px-6]="!flushBody()"
          [class.sm:py-5]="!flushBody()"
          [class.flex]="flushBody()"
          [class.flex-col]="flushBody()"
          [class.overflow-hidden]="flushBody()"
        >
          <ng-content />
        </div>

        <!-- FOOTER — template footers (wizard) keep the hairline; the config
             footer matches the confirm-dialog design: no divider, Cancel with
             an X icon on the left edge, primary on the right.
             TODO(ds): adopt app-button for the footer buttons once it lands. -->
        @if (footerTpl(); as f) {
          <div class="flex flex-none items-center gap-4 border-t border-hairline py-4 pl-5 pr-4 sm:pl-8">
            <ng-container [ngTemplateOutlet]="f.template" />
          </div>
        } @else if (hasConfigFooter()) {
          <div class="flex flex-none items-center justify-between gap-4 px-4 pb-4 pt-2 sm:px-6 sm:pb-6">
            @if (showCancel()) {
              <button
                type="button"
                (click)="dismiss()"
                class="flex h-12 items-center gap-2 rounded-control bg-card px-5 text-button font-semibold text-action shadow-raised hover:bg-sunken"
              >
                <app-icon name="icon-x" [size]="18" />
                {{ cancelLabel() ?? t('common.cancel') }}
              </button>
            } @else {
              <span></span>
            }
            @if (primaryLabel(); as label) {
              <button
                type="button"
                (click)="onPrimary()"
                [disabled]="primaryDisabled()"
                class="flex h-12 min-w-40 items-center justify-center rounded-control px-5 text-button font-semibold text-action-text shadow-raised disabled:opacity-40 hover:brightness-90"
                [class.bg-action]="!primaryDestructive()"
                [style.background]="primaryDestructive() ? 'var(--colorscales-red-500)' : null"
              >
                {{ label }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  </ng-container>
}
